import { Link } from 'react-router-dom';
import type { LucideIcon } from 'lucide-react';
import { cn } from '@/lib/utils';
import { moduleTile, type ModuleKey } from '@/lib/theme';

export type QuickAction = {
  to: string;
  icon: LucideIcon;
  title: string;
  description: string;
  module: ModuleKey;
};

type QuickActionGridProps = {
  actions: QuickAction[];
  className?: string;
};

export default function QuickActionGrid({ actions, className }: QuickActionGridProps) {
  return (
    <div className={cn('grid grid-cols-2 gap-2 sm:grid-cols-4', className)}>
      {actions.map((action) => (
        <Link
          key={action.to}
          to={action.to}
          className="flex flex-col items-center gap-2 rounded-xl border border-border bg-card p-3 text-center active:bg-muted/50"
        >
          <span className={moduleTile(action.module)}>
            <action.icon className="h-4 w-4" strokeWidth={2} />
          </span>
          <p className="text-sm font-medium text-foreground">{action.title}</p>
          <p className="text-xs text-muted-foreground">{action.description}</p>
        </Link>
      ))}
    </div>
  );
}
